import { render, staticRenderFns } from "./Gmb.vue?vue&type=template&id=56cd36d0&"
import script from "./Gmb.vue?vue&type=script&lang=js&"
export * from "./Gmb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports